import { atom, selector } from "recoil";
import { LOCAL_STORAGE_INITIAL_LEVEL } from "../helpers/consts";
import { LevelMap } from "../levels/LevelMap";

// Safely remember a level from local storage
let defaultCurrentLevel = window.localStorage.getItem(
  LOCAL_STORAGE_INITIAL_LEVEL
);
if (!LevelMap[defaultCurrentLevel]) {
  defaultCurrentLevel = "1-1";
}

const currentLevelAtom = atom({
  key: "currentLevelAtom",
  default: defaultCurrentLevel,
});

export const currentLevelSelector = selector({
  key: "currentLevelSelector",
  get: ({ get }) => {
    return get(currentLevelAtom);
  },
  set: ({ set }, newValue) => {
    window.localStorage.setItem(LOCAL_STORAGE_INITIAL_LEVEL, newValue);
    set(currentLevelAtom, newValue);
  },
});
